import { Box, Card, Typography } from '@mui/material'
import React from 'react'

const HoursCard = ({employeeData}) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
        }}>
            <Card sx={{
                height: 'auto',
                width: '100%',
                borderRadius: 3,
                overflow: "hidden",
                p: 1,
                border: '1px solid #3f51b5d4'
            }}>
                <Typography variant="h6" color='dark' sx={{ fontWeight: "bold", fontSize: '14px' }}>
                    Total Assigned Hours
                </Typography>
                <Typography variant='h3' color='text.secondary' sx={{ fontWeight: "bold", fontSize: '30px' }}>{employeeData?.weekly_summary?.assigned_hours}<span style={{ fontSize: '14px' }}>hrs</span></Typography>
            </Card>
            <Card sx={{
                height: 'auto',
                width: '100%',
                borderRadius: 3,
                overflow: "hidden",
                p: 1,
                border: '1px solid #3f51b5d4'
            }}>
                <Typography variant="h6" color='dark' sx={{ fontWeight: "bold", fontSize: '14px' }}>
                    Total Actual Hours
                </Typography>
                <Typography variant='h3' color='text.secondary' sx={{ fontWeight: "bold", fontSize: '30px' }}>{employeeData?.weekly_summary?.actual_hours}<span style={{ fontSize: '14px' }}>hrs</span></Typography>
            </Card>
        </Box>
    )
}

export default HoursCard
